import React from 'react';
import { SentimentType } from '../../../types/annotation';

interface SentimentSelectorProps {
  value: SentimentType | null;
  onChange: (v: SentimentType) => void;
  disabled?: boolean;
}

interface SentimentOption {
  value: SentimentType;
  label: string;
  activeClass: string;
  inactiveClass: string;
}

const SENTIMENT_OPTIONS: SentimentOption[] = [
  {
    value: 'positive',
    label: 'Positive',
    activeClass: 'bg-green-600 text-white ring-2 ring-green-400',
    inactiveClass: 'bg-green-50 text-green-700 hover:bg-green-100 border border-green-200',
  },
  {
    value: 'negative',
    label: 'Negative',
    activeClass: 'bg-red-600 text-white ring-2 ring-red-400',
    inactiveClass: 'bg-red-50 text-red-700 hover:bg-red-100 border border-red-200',
  },
  {
    value: 'neutral',
    label: 'Neutral',
    activeClass: 'bg-gray-600 text-white ring-2 ring-gray-400',
    inactiveClass: 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-200',
  },
  {
    value: 'mixed',
    label: 'Mixed',
    activeClass: 'bg-amber-500 text-white ring-2 ring-amber-400',
    inactiveClass: 'bg-amber-50 text-amber-700 hover:bg-amber-100 border border-amber-200',
  },
];

const SentimentSelector: React.FC<SentimentSelectorProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <div className="flex gap-2">
      {SENTIMENT_OPTIONS.map((opt) => {
        const isActive = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            disabled={disabled}
            onClick={() => onChange(opt.value)}
            className={[
              'flex-1 px-2 py-1.5 text-xs rounded-lg font-medium transition-colors',
              isActive ? opt.activeClass : opt.inactiveClass,
              disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
            ].join(' ')}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
};

export default SentimentSelector;
